'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.changeItem = changeItem;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* REDUX MAINTAIN MODULES PAGE */

var CHANGE_ITEM = 'CHANGE_PAGE';

/*
 * module is the module number, 0 to 5, 5 being booster
 * modtype is either 'App', 'Resource', 'Activities', 0, 1, 2
 * item is the nth item in the list of types
 */
var initialState = {
  '0': {
    modtype: 0,
    item: 1
  },
  '1': {
    modtype: 0,
    item: 1
  },
  '2': {
    modtype: 0,
    item: 1
  },
  '3': {
    modtype: 0,
    item: 1
  },
  '4': {
    modtype: 0,
    item: 1
  },
  '5': {
    modtype: 0,
    item: 1
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_ITEM:
      var mod = action.module;
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, mod, {
        modtype: action.modtype,
        item: action.item
      }));
    default:
      return state;
  }
}

function changeItem(mod, type, it) {
  return {
    type: CHANGE_ITEM,
    module: mod,
    modtype: type,
    item: it
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/modules.js
// module id = 17
// module chunks = 0